import { useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import { DesfaseRelojApi } from "../api/DesfaseRelojApi";
import { getErrorFromResponse } from "../../../../../utility/utils";

// Historial de cambios de un reloj; se consulta cada vez que se abre el modal
export const useHistorialDesfaseReloj = ({ contexto, opened }) => {
    const { getHistorialReloj, cargando } = DesfaseRelojApi();

    const [cambios, setCambios] = useState([]);
    const [cantidadResultados, setCantidadResultados] = useState(0);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);

    // solo se atiende la última consulta, para que una respuesta lenta no pise
    // la página que se pidió después
    const ultimaPeticion = useRef(0);

    const CargarHistorial = async () => {
        const peticion = ultimaPeticion.current + 1;
        ultimaPeticion.current = peticion;

        try {
            const response = await getHistorialReloj({
                contexto,
                page: paginaSeleccionada,
            });

            if (peticion !== ultimaPeticion.current) return;

            setCambios(response.results || []);
            setCantidadResultados(response.count || 0);
        } catch (error) {
            if (peticion !== ultimaPeticion.current) return;

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el historial del reloj",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setCambios([]);
            setCantidadResultados(0);
        }
    };

    useEffect(() => {
        if (!opened) return;

        CargarHistorial();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opened, paginaSeleccionada]);

    // al cerrar vuelve a la primera página, para abrir con el cambio más reciente
    useEffect(() => {
        if (opened) return;

        setPaginaSeleccionada(1);
    }, [opened]);

    return {
        cambios,
        cantidadResultados,
        paginaSeleccionada,
        setPaginaSeleccionada,

        cargando,
    };
};
